import { Employee } from '../../classes/models/employee/Employee';
import { GroupedAvailability } from '../../classes/models/employee/GroupedAvailability';
import { Availability } from '../../classes/models/employee/Availability';
import moment from 'moment';
import { StoreEmployeeAvailability } from '../../classes/models/employee/StoreEmployeeAvailability';
import { Injectable } from '@angular/core';

/**
 * This service groups availabilities by identical time ranges.
 */
@Injectable({
  providedIn: 'root'
})
export class GroupAvailabilitiesService {

  /**
   * Groups adjacent availabilities together by identical time ranges for each employee.
   * @param selectedMonday the Monday of the selected week.
   * @param availabilitiesByEmployee each employee's availabilities for a week.
   * @param employees employees list.
   */
  groupAvailabilities(
    selectedMonday: string,
    availabilitiesByEmployee: StoreEmployeeAvailability[],
    employees: Employee[]
  ): Map<Employee, GroupedAvailability[]> {
    const map = new Map<Employee, GroupedAvailability[]>();
    availabilitiesByEmployee.map(availabilityByEmployee => {
      const foundEmployee = employees
        .find(employee => availabilityByEmployee.employeePositionId.value === employee.employeePositionId.value);
      if (!foundEmployee) {
        return;
      }
      const availabilities = this.getAvailabilitiesForSelectedWeek(selectedMonday, availabilityByEmployee.availabilities);
      const groupedAvailabilities = GroupedAvailability.from(availabilities);
      map.set(foundEmployee, groupedAvailabilities);
    });
    return map;
  }

  private getAvailabilitiesForSelectedWeek(
    selectedMonday: string,
    availabilities: Map<string, Availability[]>
  ): Availability[] {
    const filteredDates = Array.from(availabilities.keys())
      .filter(date => date <= selectedMonday)
      .map(date => moment(date, 'YYYY-MM-DD'));
    if (filteredDates.length === 0) {
      return [];
    }
    const startDate = moment.max(filteredDates).format('YYYY-MM-DD');
    return availabilities.get(startDate);
  }
}
